import { Component, type ReactNode } from "react";

/**
 * Keeps one block that can't be shown (content saved in a shape the site no
 * longer understands, say) from blanking the whole page: visitors see the
 * page without it, the editor a quiet note in its place.
 */
export class BlockBoundary extends Component<
  { children: ReactNode; note?: boolean },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error("A block couldn't be shown", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return this.props.note ? (
      <p className="rounded-site-sm border border-dashed border-site-border px-4 py-3 text-sm text-site-muted">
        This block couldn’t be shown. You can remove it, or undo your last change.
      </p>
    ) : null;
  }
}
